let Values = {
  WALK       : 'WALK',
  TROT       : 'TROT',
  GALLOP     : 'GALLOP',
  TROT_GALLOP: 'TROT_GALLOP',
  STOP       : 'STOP',
};

export default Object.seal({
  ...Values,

  /* All values */
  values: Object.keys(Values),

  /* Get name for value. */
  name: (value) => {
    switch (value) {

      case Values.WALK:
        return "Pas";

      case Values.TROT:
        return "Trot";

      case Values.GALLOP:
        return "Galop";

      case Values.TROT_GALLOP:
        return "Trot & Galop";

      case Values.STOP:
        return "Arrêt";

      default:
        return value;
    }
  },

  /* Get short for value. */
  short: (value) => {
    switch (value) {

      case Values.WALK:
        return "Pas";

      case Values.TROT:
        return "Trot";

      case Values.GALLOP:
        return "Galop";

      case Values.TROT_GALLOP:
        return "Trot & Galop";

      case Values.STOP:
        return "Arrêt";

      default:
        return value;
    }
  }
});
